
import * as Models from "../ts/rlAdmin.models";
import * as moment from "moment";

import { RLBaseService } from "./rl-base-service";
import { PromiseCache } from "./promise-cache";
import ICorrectRelativeToDateMath = Models.ICorrectRelativeToDateMath;

export class DateCalcService extends RLBaseService {

    static $inject = ["$resource", "$q", "promiseCache"];

    parentDateFields: { [charID: number]: number };

    constructor(private $resource: ng.resource.IResourceService, private $q: ng.IQService, private promiseCache: PromiseCache) {
        super($resource);
        this.parentDateFields = {};
    }

    getDateCalcTimeframeList() {
        var key = "getdatecalctimeframetypes";
        return this.promiseCache.get(key, () => this.toRLService<Models.IDateCalcTimeframe>("/api/datecalc/getdatecalctimeframelist").query().$promise);
    }

    getDateCalcFrequencyList() {
        var key = "getdatecalctimefrequency";
        return this.promiseCache.get(key, () => this.toRLService<Models.IDateCalcFrequency>("/api/datecalc/getdatecalcfrequencylist").query().$promise);
    }

    getDateCalcFrequencyRelativeList() {
        var key = "getdatecalctimefrequencyrelative";
        return this.promiseCache.get(key, () => this.toRLService<Models.IDateCalcFrequencyRelative>("/api/datecalc/getdatecalcfrequencyrelativelist").query().$promise);
    }

    getDateCalcFrequencyIntervalList(frequencyID: number) {
        var key = `getDateCalcFrequencyIntervalList${frequencyID}`
        var data = { frequencyID: frequencyID };
        return this.promiseCache.get(key, () => this.toRLService<Models.IDateCalcFrequencyInterval>("/api/datecalc/getdatecalcfrequencyintervallist").query(data).$promise);
    }

    getEntityCharDataDates(entityID: string) {
        var data = { entityID: entityID };
        return this.toRLService<Models.ICharDataCollection>("/api/datecalc/getentitychardatadates").get(data).$promise;
    }

    getDateCalcRecalcOptionList() {
        var key = "getdatecalcrecalcoption";
        return this.promiseCache.get(key, () => this.toRLService<Models.IDateCalcRecalcOption>("/api/datecalc/getdatecalcrecalcoptionlist").query().$promise);
    }

    getDateCalcConditionList() {
        var key = "getdatecalcconditionlist";
        return this.promiseCache.get(key, () => this.toRLService<Models.IDateCalcCondition>("/api/datecalc/getdatecalcconditionlist").query().$promise);
    }

    getDateCalcDateOptionList() {
        var key = "getdatecalcdateoptionlist";
        return this.promiseCache.get(key, () => this.toRLService<Models.IDateCalcDateOption>("/api/datecalc/getdatecalcdateoptionlist").query().$promise);
    }

    createDateCalcCharacteristic(charTypeID: number, recID: number, characteristicID: number, characteristicValue: string, characteristicValueID?: number) {
        var data = {
            charTypeID: charTypeID,
            recID: recID,
            characteristicID: characteristicID,
            characteristicValue: characteristicValue,
            characteristicValueID: characteristicValueID
        };
        return this.toRLService<Models.IDataResponse<number>>("/api/datecalc/createdatecalccharacteristic").post(data).$promise;
    }

	correctRelativeToDateMath(recIDs: number[], tagLabels: string[]) {
		var data = {
			recIDs,
			tagLabels
		};
		return this.toRLService<{ assetRecCharCorrections: Models.ICorrectRelativeToDateMath[] }>("/api/datecalc/correctrelativetodatemath").post(data).$promise;
	}

    hasCircularReference(childRecCharID: number, parentRecCharID: number) {
        var data = {
            childRecCharID: childRecCharID,
            parentRecCharID: parentRecCharID
        };
        return this.toRLService<Models.IDataResponse<boolean>>("/api/datecalc/hascircularreference").get(data).$promise;
    }

    checkEntityForDateMathRelationships(entityID: string) {
        var data = {
            entityID: entityID
        };
        return this.toRLService<string>("/api/datecalc/checkentityfordatemathrelationships").query(data).$promise;
    }

    removeDateMathRelationshipsForEntity(entityID: string) {
        var data = {
            entityID: entityID
        };
        return this.toRLService<boolean>("/api/datecalc/removedatemathrelationshipsforentity").get(data).$promise;
    }

    getDateMathCalcParentInfo(rels: Models.ICharDataExtensionDataDateMathRel[]) {
        var data = rels;
        return this.toRLService<Models.ICharDataExtensionDataDateMathParentRelInfo>("/api/datecalc/getdatemathcalcparentinfo").postArray(data).$promise;
    }

    getDateMathCalcChildrenInfo(rels: Models.ICharDataExtensionDataDateMathRel[]) {
        var data = rels;
        return this.toRLService<Models.ICharDataExtensionDataDateMathChildRelInfo>("/api/datecalc/getdatemathcalcchildreninfo").postArray(data).$promise;
    }

    getDateMathRelatedEntityPairs(entityID: string, childCharTypeID: number, templateID: number, start: number, rows: number, searchKeywords?: string) {
        var data = {
            entityID,
            childCharTypeID,
            templateID,
            start,
            rows,
            searchKeywords
        };
        return this.toRLService<Models.IGetDateMathRelatedEntityPairsResponse>("/api/datecalc/getdatemathrelatedentitypairs").get(data).$promise;
    }

    getCommonDateChars(charTypeID: number){
        var data = {
            charTypeID: charTypeID
        };
        return this.toRLService<Models.ICharacteristicMetaData>("/api/datecalc/getcommondatechars").query(data).$promise;
    }
}
